export enum ManagerType {
    Mcp = 'MCP',
    Manager = 'MANAGER',
    McpGroup = 'MCPGROUP',
    Moderator = 'MODERATOR',
    HiringManager = 'HIRING_MANAGER',
}
